import React, { useState, useEffect } from "react"
import { Col, Modal, Container, Row, Card, CardBody, Form, Alert, Input } from "reactstrap"
import { connect } from "react-redux"
import { map } from "lodash"
import { withRouter, Link } from "react-router-dom"

import * as backend from "../../helpers/backend_helper"
import Toaster from "../../components/Common/Toaster"
import Breadcrumb from "../../components/Common/Breadcrumb2"
import BackButton from "../../common/ui/backButton"
import DeleteAlert from "../../common/ui/customAlert"

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { fetchFactories } from "store/slice/factory.slice"

const FactoryList = (props: any) => {
  const {
    match: {
      params: { orgId },
    },
  } = props
  const [modal_standard, setmodal_standard] = useState(false)
  const [lists, setList] = useState<any[]>([])
  const [edit, setEdit] = useState<any>(null)
  const [count, setCount] = useState(true)
  const [duplicate, setDuplicate] = useState<any>(null)

  const [deleteAlertVisible, setDeleteAlertVisible] = useState(false)
  const [deleteValue, setDeleteValue] = useState({})

  // Org-level role of the logged-in user for THIS org. Only an org Admin (or a
  // super admin) may create/duplicate/edit/delete factories; plain Members can
  // only open a factory. (org role lives in user.orgs[].org; "ADMIN" vs Member.)
  const currentUser: any = props.user
  const orgEntry: any = (currentUser && currentUser.orgs ? currentUser.orgs : [])
    .find((o: any) => String(o.orgId) === String(orgId))
  const isOrgAdmin = !!(currentUser && (currentUser.superAdmin || (orgEntry && (orgEntry.org || []).includes("ADMIN"))))

  function tog_standard() {
    setmodal_standard(!modal_standard)
    removeBodyCss()
  }
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  // handleValidSubmit
  const handleValidSubmit = async (values) => {
    if (edit) {
      update(values)
    } else if (duplicate) {
      onClone(duplicate, values.name)
    } else {
      save(values)
    }
  }

  const update = async values => {
    try {
      await backend.updateFactory(orgId, edit["_id"], values)
      props.saveUserFactory()
      getList()
      tog_standard()
    } catch (e) {
      Toaster.error(typeof e === "string" ? e : "Failed to update factory")
    }
  }

  const onClone = async (value, name) => {
    try {
      // await backend.cloneFactory(orgId, value['_id'], {name: value.name + '- clone'})
      await backend.cloneFactory(orgId, value["_id"], { name:value.name===name? value.name + '- clone' :name})
      getList();
      tog_standard()
    } catch (e) {
      Toaster.error(typeof e === "string" ? e : "Failed to clone factory")
    }
  }

  const save = async values => {
    try {
      await backend.saveFactory(orgId, values)
      props.saveUserFactory()
      getList()
      tog_standard()
    } catch (e) {
      Toaster.error(typeof e === "string" ? e : "Failed to save factory")
    }
  }

  const getList = async () => {
    try {
      const response = await backend.getFactory(orgId)
      setList(response)
    } catch (e) {}
  }

  useEffect(() => {
    if (lists.length == 0 && count) {
      getList()
      setCount(false)
    }
  }, [lists, count])

  //on edit
  const onEdit = (e, value) => {
    e.stopPropagation()
    setEdit(value)
    validation.setValues(value);
    setDuplicate(null)
    tog_standard()
  }

  //rowClick
  const rowClick = async (e, value) => {
    if (value && value.permission.includes("ADMIN"))
      props.history.push(`/orgs/list/${orgId}/factory/${value["_id"]}`)
  }
  // on onDelete
  const DeleteOrgApi = async value => {
    // e.stopPropagation();
    try {
      await backend.deleteFactory(orgId, value["_id"])
      props.saveUserFactory()
      setDeleteValue({})
      getList()
    } catch (e) {
      Toaster.error(typeof e === "string" ? e : "Failed to delete factory")
    }
  }
  // on onDelete
  const onDelete = async (e, value) => {
    e.stopPropagation()

    toggleDeleteAlert()
    setDeleteValue(value)
  }

  const Submit = () => {
    DeleteOrgApi(deleteValue)
    toggleDeleteAlert()
  }

  const toggleDeleteAlert = () => {
    setDeleteAlertVisible(!deleteAlertVisible)
  }

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Your Name"),
    }),
    onSubmit: (values) => {
      handleValidSubmit(values);
    }
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="mw-detail-header">
            <button
              type="button"
              className="mw-back-btn"
              title="Back"
              onClick={() => props.history.goBack()}
            >
              <i className="mdi mdi-arrow-left" />
            </button>
            <div className="mw-detail-titles">
              <div className="mw-crumb">
                <Link to="/orgs/list">Organization</Link>
                <span className="mw-crumb-sep">/</span>
                <span className="mw-crumb-current">Factory</span>
              </div>
              <h4>Factories</h4>
              <p>Manage Factories, Teams and Monitoring Forms</p>
            </div>
            {props.user && !props.user.orgId && isOrgAdmin && (
              <div className="mw-detail-actions">
                <button
                  type="button"
                  onClick={() => {
                    setEdit(null)
                    setDuplicate(null)
                    validation.resetForm();
                    tog_standard()
                  }}
                  className="btn btn-primary"
                >
                  <i className="mdi mdi-plus me-1" />
                  Create New
                </button>
              </div>
            )}
          </div>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="p-0">
                  <div className="table-responsive">
                    <table className="mw-table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th className="text-end">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lists.length === 0 && (
                          <tr>
                            <td colSpan={2}>
                              <div className="mw-empty-state">
                                <i className="bx bxs-factory" />
                                No factories yet
                              </div>
                            </td>
                          </tr>
                        )}
                        {map(lists, (list, index) => (
                          <tr
                            onClick={e => rowClick(e, list)}
                            key={index}
                            style={{ cursor: "pointer" }}
                          >
                            <td>
                              <span className="d-inline-flex align-items-center">
                                <span className="mw-avatar-initial">
                                  {(list.name || "?").charAt(0).toUpperCase()}
                                </span>
                                <span style={{ fontWeight: 500 }}>{list.name}</span>
                              </span>
                            </td>
                            <td className="text-end">
                              {list.permission.includes("ADMIN") && (
                                <div className="mw-actions">
                                  <button
                                    type="button"
                                    className="mw-action-btn mw-a-view"
                                    title="Configure"
                                    onClick={e => rowClick(e, list)}
                                  >
                                    <i className="bx bx-cog" />
                                  </button>
                                  {/* Duplicate / Edit / Delete are org-management
                                      actions — hidden for plain Members. */}
                                  {isOrgAdmin && (
                                    <>
                                      <button
                                        type="button"
                                        className="mw-action-btn mw-a-users"
                                        title="Duplicate"
                                        onClick={e => {
                                          e.stopPropagation()
                                          setEdit(null)
                                          setDuplicate(list)
                                          validation.resetForm();
                                          tog_standard()
                                        }}
                                      >
                                        <i className="dripicons-copy" />
                                      </button>
                                      <button
                                        type="button"
                                        className="mw-action-btn mw-a-edit"
                                        title="Edit"
                                        onClick={e => onEdit(e, list)}
                                      >
                                        <i className="bx bx-edit-alt" />
                                      </button>
                                      <button
                                        type="button"
                                        className="mw-action-btn mw-a-delete"
                                        title="Delete"
                                        onClick={e => onDelete(e, list)}
                                      >
                                        <i className="bx bx-trash-alt" />
                                      </button>
                                    </>
                                  )}
                                </div>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <DeleteAlert
        visible={deleteAlertVisible}
        Title={"Delete Factory"}
        Message={"Do you Want to Delete Factory?"}
        toggleAlert={toggleDeleteAlert}
        Submit={Submit}
      />

      <Modal
        isOpen={modal_standard}
        toggle={() => {
          tog_standard()
        }}
      >
        <Form
          className="form-horizontal"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="myModalLabel">
              {duplicate
                ? `Duplicate of "${duplicate.name}"`
                : edit
                ? "Edit Factory"
                : "Create New Factory"}
            </h5>
            <button
              type="button"
              onClick={() => {
                setmodal_standard(false)
              }}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {props.error && typeof props.error === "string" ? (
              <Alert color="danger">{props.error}</Alert>
            ) : null}

            <div className="form-group">
              <Input
                name="name"
                label="Name"
                value={validation.values.name}
                onChange={validation.handleChange}
                className="form-control"
                placeholder="Enter Org Name"
                type="text"
                required
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={() => {
                tog_standard()
              }}
              className="btn btn-secondary waves-effect"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="submit"
              className="btn btn-primary waves-effect waves-light"
            >
              Save
            </button>
          </div>
        </Form>
      </Modal>
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  const { user } = state.user
  return { user }
}

export default withRouter(
  connect(mapStateToProps, { saveUserFactory: fetchFactories })(FactoryList)
)
